import(/* webpackMode: "eager" */ "/home/hpbs/frontend/assets/policy-solution.png");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/assets/policy-stats.png");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/assets/rating-award.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/node_modules/next/dist/client/image-component.js");
